module.exports = __webpack_public_path__ + "img/usd.e3f116aa.svg";